jQuery(document).ready(function ($) {
  function pdpSlickConfig() {
    return {
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="pdp-arrow slick-custom-arrow pdp-arrow-pre"><img src="' +
        window.themeAssets.arrowBack +
        '" alt="Previous" width="24" height="24"></button>',
      nextArrow:
        '<button type="button" class="pdp-arrow slick-custom-arrow pdp-arrow-next"><img src="' +
        window.themeAssets.arrowNext +
        '" alt="Next" width="24" height="24"></button>',
    };
  }

  function initPdpImageSliders() {
    $('.pdp-images-list')
      .not('.pdp-images--bundle-galleries .pdp-images-view:not(.is-active) .pdp-images-list')
      .each(function () {
        var $el = $(this);
        if ($el.hasClass('slick-initialized')) return;
        $el.slick(pdpSlickConfig());
      });
  }

  window.themeReinitBundlePdpGalleries = function (mediaRoot) {
    var $root = $(mediaRoot).closest('.pdp-images--bundle-galleries');
    if (!$root.length) return;
    $root.find('.pdp-images-list').each(function () {
      var $l = $(this);
      if ($l.hasClass('slick-initialized')) {
        try {
          $l.slick('unslick');
        } catch (e) {}
      }
    });
    initPdpImageSliders();
  };

  initPdpImageSliders();
  $(".img-slider").slick({
    dots: true,
    infinite: false,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  $(".customer-says__grid ").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
    '<button type="button" class="slick-custom-arrow test-arrow-pre"><img src="' +
    window.themeAssets.arrowBack +
    '" alt="Previous" width="24" height="24"></button>',
  nextArrow:
    '<button type="button" class="slick-custom-arrow test-arrow-next"><img src="' +
    window.themeAssets.arrowNext +
    '" alt="Next" width="24" height="24"></button>',
    responsive: [
      {
        breakpoint: 1048,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".follow-slider").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  });
  $(".trusted-videos-list").each(function () {
    var $list = $(this);

    if ($list.hasClass("slick-initialized")) {
      try {
        $list.slick("unslick");
      } catch (e) {}
    }

    $list.removeClass(
      "trusted-videos-list--flex trusted-videos-list--single trusted-videos-list--duo trusted-videos-list--trio trusted-videos-list--slider"
    );

    var slideCount = $list.children(".trusted-video-item").length;
    if (!slideCount) return;

    // 1–3: simple flex row (no Slick)
    if (slideCount <= 3) {
      $list.addClass("trusted-videos-list--flex");
      if (slideCount === 1) $list.addClass("trusted-videos-list--single");
      if (slideCount === 2) $list.addClass("trusted-videos-list--duo");
      if (slideCount === 3) $list.addClass("trusted-videos-list--trio");
      return;
    }

    // 4+: original centered carousel style
    $list.addClass("trusted-videos-list--slider");
    $list.slick({
      dots: false,
      infinite: true,
      speed: 300,
      centerMode: true,
      centerPadding: "260px",
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="slick-custom-arrow trusted-videos-prev"><img src="' +
        window.themeAssets.arrowBack +
        '" alt="Previous" width="24" height="24"></button>',
      nextArrow:
        '<button type="button" class="slick-custom-arrow trusted-videos-next"><img src="' +
        window.themeAssets.arrowNext +
        '" alt="Next" width="24" height="24"></button>',
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 2,
            centerPadding: "160px",
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: "40px",
          },
        },
      ],
    });
  });
  $(".designed-with-purpose-slider").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  });

  $(".why-choose__mobile-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow:
      '<button type="button" class="slick-custom-arrow why-choose-prev"><img src="' +
      window.themeAssets.arrowBack +
      '" alt="Previous" width="24" height="24"></button>',
    nextArrow:
      '<button type="button" class="slick-custom-arrow  why-choose-next"><img src="' +
      window.themeAssets.arrowNext +
      '" alt="Next" width="24" height="24"></button>',
  });
});
